import { useCallback, useEffect } from 'react';

/**
 * Hook to launch the draft room in a new window and listen for close events.
 */
export function useDraftRoomLauncher(onDraftClosed?: () => void) {
  useEffect(() => {
    try {
      const bc = new BroadcastChannel('sabotage-draft');
      bc.onmessage = (event) => {
        if (event.data?.type === 'draft-room-closed') {
          onDraftClosed?.();
        }
      };
      return () => bc.close();
    } catch {
      // BroadcastChannel not supported
    }
  }, [onDraftClosed]);

  const openDraftRoom = useCallback((leagueId: string) => {
    const draftWindow = window.open(`/draft-room/${leagueId}`, '_blank');
    draftWindow?.focus();
    return draftWindow;
  }, []);

  return { openDraftRoom };
}
